export const UPDATE_STARTDATE = 'UPDATE_STARTDATE'
export const UPDATE_ENDDATE = 'UPDATE_ENDDATE'
export const UPDATE_TIMEFRAME = 'UPDATE_TIMEFRAME'
export const UPDATE_TIMEFRAME_WITH_DATERANGE = 'UPDATE_TIMEFRAME_WITH_DATERANGE'
export const CHANGE_TIMEFRAMETYPE = 'CHANGE_TIMEFRAMETYPE'
export const UPDATE_TIMEFRAME_BUTTONS = 'UPDATE_TIMEFRAME_BUTTONS'

export function updateStartDate (date) {
  return {
    type: UPDATE_STARTDATE,
    payload: date
  }
}

export function updateEndDate (date) {
  return {
    type: UPDATE_ENDDATE,
    payload: date
  }
}

export function updateTimeframe (date) {
  return {
    type: UPDATE_TIMEFRAME
  }
}

export function changeTimeframeType (type) {
  return {
    type: CHANGE_TIMEFRAMETYPE,
    payload: type
  }
}

export function updateTimeframeWithDateRange (startDate, endDate) {
  return {
    type: UPDATE_TIMEFRAME_WITH_DATERANGE,
    payload: {
      startDate,
      endDate
    }
  }
}

export function updateTimeframeButtons (timeframeButtons) {
  return {
    type: UPDATE_TIMEFRAME_BUTTONS,
    payload: timeframeButtons
  }
}



// WEBPACK FOOTER //
// ./src/actions/timeframe.js